module.exports = __webpack_public_path__ + "img/calculator_icon.0187e87b.svg";